import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import AddResourceHeader from './AddResourceHeader';

type ResourceHeaderCellsProps = {
  resourceColumns: string[];
  readOnly?: boolean;
  onAddResource: (name: string) => void;
  onDeleteResource: (name: string) => void;
};

const RESOURCE_COL_STYLE: React.CSSProperties = { minWidth: 160 };

export const ResourceMainHeaderCells: React.FC<ResourceHeaderCellsProps> = ({
  resourceColumns,
  readOnly = false,
  onAddResource,
}) => {
  const groupColSpan = 1 + Math.max(1, resourceColumns.length);
  return (
    <>
      <th
        colSpan={groupColSpan}
        style={{ paddingLeft: '80px', borderBottom: 'none' }}
      >
        Kinds of Resources
      </th>
      <th rowSpan={2} style={{ minWidth: 180 }}>
        {!readOnly && <AddResourceHeader onAdd={onAddResource} />}
      </th>
    </>
  );
};

export const ResourceSubHeaderCells: React.FC<
  Pick<
    ResourceHeaderCellsProps,
    'resourceColumns' | 'readOnly' | 'onDeleteResource'
  >
> = ({ resourceColumns, readOnly = false, onDeleteResource }) => (
  <>
    <th style={{ minWidth: 80 }} />
    {resourceColumns.length === 0 ? (
      <th style={RESOURCE_COL_STYLE} className="text-muted text-center">
        <em>No resources</em>
      </th>
    ) : (
      resourceColumns.map((name) => (
        <th key={name} style={RESOURCE_COL_STYLE}>
          <div className="d-flex align-items-center justify-content-between gap-2">
            <span>{name}</span>
            {!readOnly && (
              <StylishNewButton
                className="button--link"
                onClick={() => onDeleteResource(name)}
              >
                <SharedIcon iconName="delete" color="danger" size="sm" />
              </StylishNewButton>
            )}
          </div>
        </th>
      ))
    )}
  </>
);
